import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Flex } from 'reflexbox';

import { useQueryParameters } from '@treams/treams-hooks';
import { useCreateNoteMutation, useShareNoteMutation } from '@treams/treams-network';
import { Spinner } from '@treams/treams-ui';

const NewNote = () => {
	const [create] = useCreateNoteMutation();
	const [share] = useShareNoteMutation();
	const history = useHistory();
	const { params } = useRouteMatch<{ collaboratorID?: string; subjectID?: string }>();

	// This is used to create new notes in the context of a user, when coming from the managing mode.
	const userID = useQueryParameters(['userID']).userID;

	useEffect(() => {
		(async () => {
			const response = await create({
				variables: { input: { subjectID: params.subjectID } },
			});

			if (params.collaboratorID) {
				await share({
					variables: {
						input: { noteID: response.data!.createNote.note.id, userID: params.collaboratorID },
					},
				});
			}

			const notesPath = userID ? `/users/${userID}/notes` : '/notes';
			history.push(`${notesPath}/${response.data!.createNote.note.id}`);
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Flex my={4} justifyContent="center">
			<Spinner />
		</Flex>
	);
};

export default NewNote;
